
import { Component, Vue, Prop, Emit, Watch } from 'vue-property-decorator';
import Button from '../../../core/components/Generics/Button.vue';
import InputFile from '../../../core/components/Generics/InputFile.vue';
import Combobox from '../../../core/components/Generics/Combobox/Combobox.vue';
import { ComboSelectedOption } from '../../../core/components/Generics/Combobox/Combobox';
import OverwriteGeneralMapOption from '../OverwriteGeneralMapOption.vue';
import RequestDialog from '../../../core/components/Generics/RequestDialog.vue';
import { ItemServices } from '../../../../features/core/api/ItemServices';
import { Feature, FeatureCollection } from '../../../../features/typescript/MapShapes';
import { addUniqueIdToGeojsonFeatures, filterFeaturesById, filterPolygonFeatures, generateTableFromGeoJSON } from '../../../../features/helpers/geojson';
import SimpleMap from '../../../core/components/Map/SimpleMap.vue';
import MapPolygons from './MapPolygons.vue';
import { convertToGeoJSON } from '../../../../features/core/utils/map-utils';
import { EventBus, TypeEventBus } from '../../../../features/core/utils';
@Component({
  components: {
    Combobox,
    Button,
    RequestDialog,
    InputFile,
    OverwriteGeneralMapOption,
    SimpleMap,
    MapPolygons
  },
})
export default class AddPolygonsFromFile extends Vue {
  visible: boolean = true;
  modalTitle: string = 'Subir archivo';
  inputLabel: string = 'Seleccionar archivo';
  allowedFormats: string = '.geojson,.kml,.kmz';
  subtitle: string = `Formatos aceptados: .geojson, .kmz, .kml`;
  processedInfo: boolean = false;
  showPolygonsOnMap: boolean = false;
  dialog = false;
  loading = false;
  success = false;
  error = false;
  dialogTitle = 'Guardando...';
  errorDescription: string = '';
  successMessage = 'Guardado correctamente.';
  errorMessage = 'Ocurrió un error.';
  headersTable:Array<object> = [{
    
  }];
  tableData:Array<object> = [];
  geojsonData: any = null;
  selectedRows: Array<any> = [];
  polygonsUniqueId: string = 'feature_unique_id';
  overwriteGeneralMap: boolean = false;

  get areSelectedRows() {
    return this.selectedRows.length > 0
  }

  @Watch('selectedRows', {
    immediate: true
  })
  onSelectedRowsChanged(selectedRows) {
    for (let index = 0; index < this.tableData.length; index++) {
      let row = this.tableData[index];
      let rowIsSelected = selectedRows.indexOf(row) !== -1;
      this.$set(row, 'checked', rowIsSelected);
    }
    this.sortTableByChecked();
  }

  clickSave(){
    let item_id = this.polygonsUniqueId;
    const selectedIds = this.selectedRows.map(item => item[item_id]);
    let filteredFeatures = filterFeaturesById(this.geojsonData, selectedIds);
    this.changePolygonInMap(filteredFeatures, this.overwriteGeneralMap)
    this.closeModal();
  }

  @Emit()
  changePolygonInMap(newPolygon, overwrite: boolean = false){}



  onSelectedPolygonsInMap(selectedFeaturesInMap: Array<Feature>){
    this.selectedRows = [];
    let self = this;

   //Recorro las features que estan seleccionadas en el mapa
    selectedFeaturesInMap.forEach((selectedFeature:any) => {
      //Busco la feature en la tabla de items
      let selectedFeatureId = selectedFeature.getProperty(self.polygonsUniqueId);
      let indexInPolygonsList = this.tableData.findIndex((item: any) => {
        return item[self.polygonsUniqueId] == selectedFeatureId
      })

      if(indexInPolygonsList !== -1){
        let itemInTable = this.tableData[indexInPolygonsList];
        this.$set(itemInTable, 'checked', true);
        this.selectedRows.push(itemInTable);
      }
    })
  }


  sortTableByChecked(){
     this.tableData = this.tableData.sort((a,b ) => {
      let a_is_checked = a['checked'] || false;
      let b_is_checked = b['checked'] || false;
      if (b_is_checked && !a_is_checked) return 1;
      if (a_is_checked && !b_is_checked) return -1;
      return 0;
    });
  }

  clearInputModel(){
      let inputFile: any = this.$refs.inputFileRef;
      if (inputFile) {
          inputFile.clearModel();
      }
      this.processedInfo = false;
    }

  viewPolygonsOnMap(){
    this.showPolygonsOnMap = true;
  }

  @Emit()
  closeModal() {}

  onSelectedFile(file) {
    if(!file || file.length == 0) return 
    this.uploadFile(file);
  }

  uploadFile(file) {
    this.processedInfo = false;
    const fileName = file.name.toLowerCase();

    const processGeojson = (featureCollection: FeatureCollection) => {
      const polygonOnly = filterPolygonFeatures(featureCollection);

      if (!polygonOnly.features.length) {
        EventBus.$emit(
          TypeEventBus.SHOW_MESSAGE,
          'El archivo no tiene poligonos validos para mostrar',
          'error'
        );
        this.processedInfo = false;
        this.geojsonData = null;
        this.tableData = [];
        this.headersTable = [];
        this.selectedRows = [];
        return;
      }

      this.geojsonData = addUniqueIdToGeojsonFeatures(polygonOnly);
      
    
      const geojsonBlob = new Blob([JSON.stringify(polygonOnly)], { type: "application/json" });
      readFile(geojsonBlob, (geojson) => {
        let { headers, rows } = generateTableFromGeoJSON(geojson);
        this.headersTable = headers;
        this.tableData = rows;
        this.processedInfo = true;
      });
    };

    const readFile = (file, callback) => {
      const reader = new FileReader();
      reader.readAsText(file);

      reader.onload = (event: any) => {
        try {
          const geojson = JSON.parse(event.target.result);
          callback(geojson);
        } catch (error) {
          console.error("Error al procesar el archivo como GeoJSON:", error);
        }
      };

      reader.onerror = (error) => {
        console.error("Error al leer el archivo:", error);
      };
    };

    if (fileName.endsWith('.kml') || fileName.endsWith('.kmz')) {
      const formData = new FormData();
      formData.append('file', file);

      this.processingFile();
      ItemServices.getGeojsonFile(formData)
        .then((response) => {
          const geojson = response;
          if (geojson) {
            processGeojson(geojson);
          } else {
            console.error("No se recibió archivo del Web Service.");
          }

          this.processingFileSuccess();
        })
        .catch((error) => {
          this.processingFileError(error);
          
        });
    } else if (fileName.endsWith('.geojson')) {

      // Leer y procesar el archivo GeoJSON directamente
      readFile(file, (geojson) => {
        processGeojson(geojson);
      });
    } else {
      //console.error("Formato de archivo no soportado.");
    }
}


  processingFile(){
     this.dialog = true;
      this.loading = true;
      this.success = false;
      this.error = false;
      this.dialogTitle = 'Procesando archivo...';
  }

  processingFileSuccess(){
    this.resetDialog();
  }

  processingFileError(error){
    this.loading = false;
    this.error = true;
    this.success = false;
    if(error && error.response && error.response.data && error.response.data.message){
      this.errorDescription = error.response.data.message
    }
    this.dialogTitle = 'Ocurrio un error';
  }


  closeDialog() {
    this.dialog = false;
    this.resetDialog();
  }

  resetDialog() {
    this.loading = false;
    this.success = false;
    this.error = false;
    this.errorDescription = '';
    this.dialogTitle = '';
    this.dialog = false;
  }



  clearFile() {
    this.clearInputModel();
  }
}
